"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Luggage32RuFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Luggage32RuFilled = function Luggage32RuFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 15h36a4 4 0 014 4v18a4 4 0 01-4 4H6a4 4 0 01-4-4V19a4 4 0 014-4zm12-5v5h12v-5a1 1 0 00-1-1H19a1 1 0 00-1 1zm0-3h12a2 2 0 012 2v6H16V9a2 2 0 012-2z",
    fill: "#97BA1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.28 33.246c2.133 0 3.719-1.23 3.719-2.926 0-1.346-.84-2.215-2.18-2.42v-.116c1.045-.28 1.79-1.066 1.797-2.256.007-1.415-1.176-2.638-3.274-2.638-2.14 0-3.48 1.21-3.569 2.94h1.655c.075-.985.745-1.532 1.818-1.532 1.046 0 1.668.642 1.668 1.456 0 .895-.697 1.524-1.709 1.524H9.002v1.32h1.237c1.217 0 1.955.608 1.955 1.6 0 .956-.8 1.599-1.934 1.599-1.142 0-1.914-.588-1.99-1.504H6.583c.082 1.784 1.552 2.953 3.698 2.953zM22.735 33v-1.463h-4.457v-.116l2.12-2.085c1.695-1.661 2.194-2.461 2.194-3.61 0-1.64-1.333-2.836-3.295-2.836-2.058 0-3.507 1.299-3.507 3.165h1.654c0-1.04.684-1.75 1.757-1.75 1.032 0 1.648.69 1.648 1.586 0 .752-.301 1.223-1.545 2.481l-3.418 3.439V33h6.85zm7.458 0v-3.227h.39L33.071 33h2.058l-3.165-4.013 3.021-3.459H33.03l-2.46 3.001h-.377v-3h-1.695V33h1.695zm8.149 0v-6.145h3.343v-1.327h-5.038V33h1.695z",
    fill: "#fff"
  }));
};

exports.Luggage32RuFilled = Luggage32RuFilled;
var _default = Luggage32RuFilled;
exports.default = _default;